'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagCnAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0 8.88109e-06C9.33333 -8.36891e-05 18.6667 0 28 0C28 6.66667 28 13.3333 28 20C18.6667 20 9.33333 20 0 20V8.88109e-06Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M0 8.88109e-06L28 0V20H0V8.88109e-06Z", fill: "#F1361D" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M9.91048 2.76879L10.8751 2.80997L11.1062 3.74738L11.4882 2.83053L12.4542 2.8541L11.7258 2.24628L12.0917 1.32343L11.2594 1.86463L10.5196 1.27071L10.7337 2.21301L9.91048 2.76879Z",
          fill: "#FFDC42"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M11.7497 5.43819L12.6756 5.71153L12.673 6.677L13.2656 5.87983L14.1972 6.13643L13.6374 5.37041L14.2158 4.56353L13.2773 4.88728L12.7031 4.13199L12.6829 5.0981L11.7497 5.43819Z",
          fill: "#FFDC42"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M13.3092 9.42014L12.5367 9.99921L12.8217 9.04773L12.0592 8.45413L13.0079 8.44514L13.3092 7.49921L13.6105 8.44514L14.5592 8.45413L13.7967 9.04773L14.0818 9.99921L13.3092 9.42014Z",
          fill: "#FFDC42"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M10.1203 12.1428L11.0535 11.8953L11.5529 12.7216L11.645 11.7326L12.5744 11.4679L11.6981 11.1041L11.7731 10.1142L11.1394 10.8784L10.2564 10.5314L10.741 11.3674L10.1203 12.1428Z",
          fill: "#FFDC42"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.66667 8.22667L4.31553 9.90273L5.18302 7.14873L2.86244 5.4306L5.74972 5.4046L6.66667 2.66667L7.58361 5.4046L10.4709 5.4306L8.15032 7.14873L9.01781 9.90273L6.66667 8.22667Z",
          fill: "#FFDC42"
        }
      )
    ]
  }
);
const VpFlagCnAsset = forwardRef(FlagCnAsset);

export { VpFlagCnAsset as default };
